var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInsuredTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.8 8C0.8 4.02375 4.02375 0.8 8 0.8C11.9762 0.8 15.2 4.02375 15.2 8C15.2 11.9762 11.9762 15.2 8 15.2C4.02375 15.2 0.8 11.9762 0.8 8ZM10.9538 8H9.41539H8.61539H8.49231V4.06154C8.49231 3.93097 8.44044 3.80575 8.34811 3.71342C8.25579 3.6211 8.13057 3.56923 8 3.56923C7.86943 3.56923 7.74421 3.6211 7.65189 3.71342C7.55956 3.80575 7.50769 3.93097 7.50769 4.06154V8.49231C7.50769 8.62288 7.55956 8.7481 7.65189 8.84042C7.74421 8.93275 7.86943 8.98462 8 8.98462H10.9538C11.0844 8.98462 11.2096 8.93275 11.302 8.84042C11.3943 8.7481 11.4462 8.62288 11.4462 8.49231C11.4462 8.36174 11.3943 8.23652 11.302 8.14419C11.2096 8.05187 11.0844 8 10.9538 8ZM8 0C3.58192 0 0 3.58192 0 8C0 12.4181 3.58192 16 8 16C12.4181 16 16 12.4181 16 8C16 3.58192 12.4181 0 8 0ZM1.6 8C1.6 4.46554 4.46554 1.6 8 1.6C11.5345 1.6 14.4 4.46554 14.4 8C14.4 11.5345 11.5345 14.4 8 14.4C4.46554 14.4 1.6 11.5345 1.6 8Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsuredTime);
export default __webpack_public_path__ + "static/media/icon_insured_time.5996af8fd9166480101139bd8a4ea23e.svg";
export { ForwardRef as ReactComponent };